import { render, staticRenderFns } from "./CompanyFormView.vue?vue&type=template&id=15899b03"
import script from "./CompanyFormView.vue?vue&type=script&lang=js"
export * from "./CompanyFormView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports